
import WritingTest from '@/models/test/WritingTest'
import WritingTestAnswer from '@/models/test/WritingTestAnswer'

export default function writing (Vue) {
  Vue.prototype.$WritingTest = WritingTest
  Vue.prototype.$WritingTestAnswer = WritingTestAnswer

  // 필답평가 문제지 목록 받기
  Vue.prototype.$getWritingTest = async function (training) {
    let tests = await WritingTest.list({ training })
    tests = tests.reduce((acc, cur) => {
      if (!acc[cur.code]) acc[cur.code] = {}
      acc[cur.code][cur.seq] = cur
      return acc
    }, {})
    return tests
  }

  // 필답 평가 답지 목록 받기
  Vue.prototype.$getWritingTestAnswer = async function (student) {
    let answers = await WritingTestAnswer.list({ student })
    answers = answers.reduce((acc, cur) => {
      if (!acc[cur.code]) acc[cur.code] = {}
      acc[cur.code][cur.seq] = cur
      return acc
    }, {})
    return answers
  }

  // 문제지와 답지 받기
  Vue.prototype.$getWritingTestAndAnswer = async function ({ test, answer }) {
    test = await WritingTest.get(test)
    answer = await WritingTestAnswer.get(answer)
    return { test, answer }
  }

  // 문제지와 새로운 답지 받기
  Vue.prototype.$getWritingTestAndNewAnswer = async function ({ training, student, code, seq }) {
    const test = await WritingTest.get({ training, code, seq })
    const name = test.lectureName
    const answer = WritingTestAnswer.create(training, student, test, name, code, seq)
    return { test, answer }
  }
}
